import { render, staticRenderFns } from "./RezultatiSingleCard.vue?vue&type=template&id=32faa021&scoped=true&"
import script from "./RezultatiSingleCard.vue?vue&type=script&lang=js&"
export * from "./RezultatiSingleCard.vue?vue&type=script&lang=js&"
import style0 from "./RezultatiSingleCard.vue?vue&type=style&index=0&id=32faa021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32faa021",
  null
  
)

export default component.exports